import { LinkButton, Spacer } from '@dot/design-system';
import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { Heading, Text } from '../../styles';

import { Hints } from './hints';
import { Steps } from './steps';

import ChevronLeftIcon from '@/assets/icons/chevron-left.svg?react';

const BackButton = styled(LinkButton)`
  margin-right: auto;
  margin-bottom: 0.3125rem;
  color: ${(p) => p.theme.colors.oxfordBlue[100]};
`;

type Props = {
  onBackClick: () => void;
};

export const QrScanTutorial = ({ onBackClick }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <BackButton leftIcon={<ChevronLeftIcon />} onClick={onBackClick}>
        {t('steps.mobileRedirect.tutorial.backButton')}
      </BackButton>
      <Heading>{t('steps.mobileRedirect.tutorial.heading')}</Heading>
      <Spacer $top={0.625}>
        <Text>{t('steps.mobileRedirect.tutorial.subheading')}</Text>
      </Spacer>
      <Spacer $top={2.5}>
        <Steps />
      </Spacer>
      <Hints />
    </>
  );
};
